import { IndexedDBStorage } from './indexed-db-storage';
import { LocalStorage } from './local-storage';
import { NoOpStorage } from './no-op-storage';
import { StorageTypes } from './types';
export class WebStorage {
    constructor(appName, storeName) {
        /**
         * opinionating on choosing indexeddb as the primary choice for web storage
         * If indexeddb is not supported, falling back on local storage,
         *
         * Both IndexedDBStorage and LocalStorage honor Storage interface,
         * all operations are done on the storage instance
         */
        this.type = StorageTypes.LocalStorage;
        if (typeof window === 'undefined') {
            this.storage = new NoOpStorage();
            this.type = StorageTypes.NoOp;
        }
        else if (IndexedDBStorage.isSupported()) {
            this.storage = new IndexedDBStorage(appName, storeName);
            this.type = StorageTypes.IndexedDB;
        }
        else {
            this.storage = new LocalStorage(appName, storeName);
            this.type = StorageTypes.LocalStorage;
        }
    }
    async set(key, value, expiryOrOptions) {
        return await this.storage.set(key, value, expiryOrOptions);
    }
    async get(key) {
        return await this.storage.get(key);
    }
    async getMany(keys) {
        return await this.storage.getMany(keys);
    }
    async remove(key) {
        return await this.storage.remove(key);
    }
    async clear() {
        return await this.storage.clear();
    }
    async isExpired(key) {
        return await this.storage.isExpired(key);
    }
    async getAllKeys() {
        return await this.storage.getAllKeys();
    }
}
